import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const ArrowTopLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M12 21L12 3M12 3L19 10M12 3L5 10", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
ArrowTopLine.iconName = 'arrow-top';
ArrowTopLine.displayName = 'ArrowTopLine';
export default ArrowTopLine;
